import { useEffect } from 'react';
import hotKeyMaps, { HotKey } from '@/config/hotKeys';
import CmdEnum from '@/constants/CmdEnum';
import { atInput, getInputHotKeys } from '@/helpers/HotKey';
import KeyCodeMap from '@/constants/KeyCode';
import CmdManager from './Cmd';
import { checkCmpInVisibleArea } from '@/utils/move';
import { app } from '@/store';

export default function KeyboardManager() {
  /**
   * 执行快捷键命令
   */
  const pressHotKey = (hotKey: HotKey) => {
    CmdManager.execute(hotKey.name);
  };

  /**
   * 处理键盘事件
   */
  const handleKeyDown = (e: KeyboardEvent) => {
    const keyCode = e.keyCode || e.which;

    const { shiftKey, ctrlKey, altKey, metaKey } = e;

    // 兼容win和mac
    const ctrl = metaKey || ctrlKey;

    for (const keyBoard of hotKeyMaps) {
      // 键值未注册
      if (!keyBoard) continue;

      const code = keyBoard.keyCode;

      if (Array.isArray(code)) {
        if (!code.includes(keyCode)) continue;
      } else if (code !== keyCode) {
        continue;
      }

      if ((shiftKey && !keyBoard.shiftKey) || (keyBoard.shiftKey && !shiftKey))
        continue;

      if ((ctrl && !keyBoard.ctrlKey) || (keyBoard.ctrlKey && !ctrl)) continue;

      if ((altKey && !keyBoard.altKey) || (keyBoard.altKey && !altKey))
        continue;

      if (
        atInput(e.target as HTMLElement) &&
        getInputHotKeys().includes(keyBoard)
      )
        return;

      // 保留系统粘贴
      if (keyBoard.name !== CmdEnum.PASTE) e.preventDefault();

      pressHotKey(keyBoard);
      break;
    }
  };

  const handleKeyUp = (e: KeyboardEvent) => {
    const keyCode = e.keyCode || e.which;
    const directionKeys = [
      KeyCodeMap.UP,
      KeyCodeMap.DOWN,
      KeyCodeMap.LEFT,
      KeyCodeMap.RIGHT,
    ];
    // 监听方向键移动组件，检查是否在可视区域
    if (directionKeys.includes(keyCode)) {
      const { activedCmps } = app;
      if (activedCmps[0]) checkCmpInVisibleArea(activedCmps[0]);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown, false);
    document.addEventListener('keyup', handleKeyUp, false);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);

  return null;
}
